import { memo, useEffect, useMemo, useState, useRef } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import sadCloud from "@assets/images/sad.png";
import os from "@utils/os.js";
import useResize from "./hooks/useResize";

import {
  getApps,
  getAppSettings,
  getCurrentTranslations,
  getTranslations,
  setOnline,
} from "@server/requests";
import {
  selectCtrl,
  selectIsPlayerOpen,
  setCtrl,
  setIsUpdateModalOpen,
} from "@app/global";
import { selectCurrentChannel } from "@app/channels/channelsSlice";
// import "@ino-ui/tv/index.css";
// import "@ino-ui/tv/src/styles/styles.css";

import { InoButton, InoRow } from "@ino-ui/tv";
import { useTranslation } from "react-i18next";
import TranslationProvider from "./TranslationProvider";

import PATHS from "@utils/paths.js";

import SplashScreen from "@pages/splash-screen/Index.jsx";
import ActivationPage from "@pages/activationPage/Index.jsx";
import Menu from "@pages/menu/Index.jsx";
import LivePage from "@pages/live/Index.jsx";
import Settings from "@pages/settings/Index.jsx";
import MoviesPage from "@pages/movies/Index.jsx";
import MovieInfo from "@pages/movieInfo/Index.jsx";
import { ToastProvider } from "./hooks/useToast";
import { ToastProvider as InoToastProvider } from "@ino-ui/tv";
import useConnection from "./hooks/useConnection";
import { MoviesProvider } from "./context/moviesContext";
import AppsPage from "@pages/apps/Index.jsx";
import { Modal } from "@ino-ui/tv";
import "./styles/global.css";
import { validateToken } from "@server/requests";
import LOCAL_STORAGE from "@utils/localStorage";
import { setAllSettings, setConfigs } from "@app/configs/configsSlice";
import useKeydown from "@hooks/useKeydown";
import { useSocket } from "@hooks/useSocket";

window.setRequestResult = (url, code, response) => {
  try {
    if (code == 200) {
      const sriptEl = document.getElementById("bundlejs");
      const hostUrl =
        sriptEl.src.split("bundle.js")[0] + "version.json?" + Date.now();
      if (url === hostUrl) {
        console.log(JSON.parse(atob(response)), "atob get res", url);
      }
    } else {
      console.log(code, response);
    }
  } catch (e) {}
};

window.TCTV = {
  goHome: function () {
    dispatchEvent(new CustomEvent("goHome", {}));
  },
};

function reloadScript() {
  try {
    let oldScript = document.getElementById("bundlejs"); // Find by ID

    if (oldScript) {
      oldScript.remove(); // Remove old script if it exists
      console.log("Old script removed.");
    } else {
      console.warn("Script not found! Creating a new one...");
    }

    // Create a new script element
    const newScript = document.createElement("script");
    newScript.id = "bundlejs"; // Set ID
    newScript.src = `http://dev.tctv.ge/bundle.js?cache_bust=${Date.now()}`;
    newScript.onload = () => console.log("New script loaded:", newScript.src);

    document.body.appendChild(newScript); // Attach to body
  } catch (e) {}
}

// Call reloadScript once when the app is opened
// reloadScript();

export const getVersion = (callback) => {
  if (window.Android) {
    try {
      // const version = window.Android.getAppVersion();
      // localStorage.setItem("app_version", version);
      const sriptEl = document.getElementById("bundlejs");
      const hostUrl =
        sriptEl.src.split("bundle.js")[0] + "version.json?" + Date.now();
      window.Android.getFromUrlB64(hostUrl);
      if (callback) {
        callback();
      }
    } catch (error) {}
  } else {
    var req = new XMLHttpRequest();

    req.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        let data = JSON.parse(this.responseText);

        let VERSION = data.version;

        if (localStorage.getItem("app_version") == VERSION) {
          localStorage.setItem("app_version", VERSION);
        } else {
          localStorage.setItem("app_version", VERSION);
          if (window.Android) {
            window.Android.reload();
          } else {
            window.location.reload();
          }
        }
      }
    };
    req.onerror = function () {};

    try {
      let host = "";
      const sriptEl = document.getElementById("bundlejs");
      if (sriptEl) {
        host = sriptEl.src.split("bundle.js")[0];
      }
      req.open("GET", host + "/version.json", true);
      req.send();
    } catch (error) {}
  }

  setTimeout(function () {
    getVersion();
  }, 300000);
};

getVersion();

function App() {
  const dispatch = useDispatch();
  const isPlayerOpen = useSelector(selectIsPlayerOpen);
  const currentChannel = useSelector(selectCurrentChannel);
  const onlineIntervalRef = useRef(null);
  const isConnected = useConnection();
  const [apkUrl, setApkUrl] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const socket = useSocket();
  const ctrl = useSelector(selectCtrl);
  const [isBlocked, setIsBlocked] = useState(false);
  const [isApkModalOpen, setIsApkModalOpen] = useState(false);
  const [lockMessage, setLockMessage] = useState("");
  const [translationId, setTranslationId] = useState(null);

  useResize();

  useKeydown({
    isActive: true,
    goHomeKey: () => {
      localStorage.setItem("home_key_pressed", "true");
      navigate("/");
    },
  });

  const getConfigs = async () => {
    try {
      const lang = JSON.parse(localStorage.getItem("language"));

      if (lang) {
        const langId = lang.id;
        const configs = await getAppSettings({
          languageId: langId,
        });
        const parsedConfigs = JSON.parse(configs);
        const { message } = parsedConfigs;

        dispatch(setAllSettings(message));

        console.log(message, "messsage");

        // Store app_settings in localStorage for easy access
        if (message?.app_settings) {
          localStorage.setItem(
            "app_settings",
            JSON.stringify(message.app_settings),
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getAppsHandler = async () => {
    try {
      // Check if launcher functionality is enabled
      const appSettings = localStorage.getItem("app_settings");
      if (appSettings) {
        const settings = JSON.parse(appSettings);
        if (settings.launcher === false) {
          return;
        }
      }

      const res = await getApps({
        device_id: LOCAL_STORAGE.MAC_ADDRESS.GET(),
      });

      const parsedRes = JSON.parse(res);
      const version = parsedRes.message[0].version_string;
      const appId = parsedRes.message[0].app_id;
      const apk = parsedRes.message[0].apk;
      const appVersion = window.Android.getAppVersion(appId);
      setApkUrl(apk);
      const realVersion = appVersion.slice(
        appVersion.indexOf("(") + 1,
        appVersion.indexOf(")"),
      );

      const versionApp = window.Android.getAppVersion(appId);
      localStorage.setItem("app_version", versionApp);

      if (realVersion < version) {
        if (window.Android) {
          setIsApkModalOpen(true);
          dispatch(setIsUpdateModalOpen(true));
        } else {
          setIsApkModalOpen(false);
          dispatch(setIsUpdateModalOpen(false));
        }
      } else {
        setIsApkModalOpen(false);
        dispatch(setIsUpdateModalOpen(false));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleValidateToken = async () => {
    const token = LOCAL_STORAGE.TOKEN.GET();
    const response = await validateToken({ token });
    const parsedResponse = JSON.parse(response);
    const { message, error } = parsedResponse;
    if (error) {
      LOCAL_STORAGE.LAST_CHANNEL_ID.REMOVE();
      navigate("/");
    } else {
      localStorage.setItem(
        "parental_code",
        JSON.stringify(message.parental_code),
      );
    }
  };

  const sendOnlineStatus = async () => {
    try {
      // Don't send online status if user is not authenticated
      const token = LOCAL_STORAGE.TOKEN.GET();
      if (!token || token === "undefined") {
        return;
      }

      const body = {
        isLive: false,
      };

      try {
        const url = new URL(window.location.href);
        const pathname = url.pathname;
        const isLiveContent =
          pathname.includes("/live") || url.href.includes("/live");

        body.isLive = isLiveContent;
        if (isPlayerOpen) {
          if (isLiveContent) {
            body.channelId = currentChannel?.id;
          } else if (pathname.includes("/movies/")) {
            const pathParts = pathname.split("/");
            const movieId = pathParts[pathParts.length - 1].split("#")[0];
            body.movieId = movieId;
          }
        }
      } catch (urlError) {
        const pathname = window.location.href;
        const isLiveContent = pathname.includes("/live");

        body.isLive = isLiveContent;
        if (isPlayerOpen) {
          if (pathname.includes("/live")) {
            body.channelId = currentChannel?.id;
          } else {
            // Extract movie ID more carefully
            const parts = pathname.split("/");
            const lastPart = parts[parts.length - 1];
            const movieId = lastPart.split("#")[0];
            body.movieId = movieId;
          }
        }
      }

      await setOnline(body);
    } catch (error) {
      if (error.code === 403) {
        LOCAL_STORAGE.TOKEN.REMOVE();
        LOCAL_STORAGE.LAST_CHANNEL_ID.REMOVE();
        navigate("/");
      }
      console.error("Failed to send online status:", error);
    }
  };

  const updateApkHandler = () => {
    const splited = apkUrl.split("/");
    const fileName = splited[splited.length - 1];
    window.Android?.installApp(apkUrl, fileName);
  };

  const getCurrentTranslationsHandler = async (lang) => {
    try {
      const res = await getCurrentTranslations({ id: lang.id });
      const parsedRes = JSON.parse(res);
      const { message } = parsedRes;
      console.log(message, "parseeee lang translation", lang);
    } catch (err) {
      console.log(err);
    }
  };

  const getTranslationsHandler = async () => {
    try {
      const res = await getTranslations();
      const parsedRes = JSON.parse(res);
      const { message } = parsedRes;

      // const defaultLang = message.find((item) => item.default);
      const defaultLangId = JSON.parse(localStorage.getItem("userLangId"));
      const defaultLang = message.find((item) => +item.id === +defaultLangId);

      if (defaultLang) {
        getCurrentTranslationsHandler(defaultLang);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!socket) return;

    socket.on("connect", () => {
      console.log("socket connected");
    });

    socket.on("user_blocked", (data) => {
      const control = ctrl;
      if (data) {
        if (data.is_blocked) {
          setIsBlocked(true);
          localStorage.setItem("is_blocked", true);
          setLockMessage(data.message);
          dispatch(setCtrl("blocked"));
        } else {
          setIsBlocked(false);
          localStorage.removeItem("is_blocked");
          setLockMessage("");

          dispatch(setCtrl(control));
        }
      }
    });

    return () => {
      socket.off("reply");
    };
  }, [socket]);

  useEffect(() => {
    sendOnlineStatus();

    onlineIntervalRef.current = setInterval(sendOnlineStatus, 120000);

    return () => {
      if (onlineIntervalRef.current) {
        clearInterval(onlineIntervalRef.current);
      }
    };
  }, [isPlayerOpen, currentChannel?.id]);

  useEffect(() => {
    if (window.Android) {
      getAppsHandler();
    }
    // getTranslationsHandler();
  }, []);

  useEffect(() => {
    window.addEventListener("goHome", () => {
      localStorage.setItem("home_key_pressed", "true");
      navigate("/");
    });

    return () => {
      window.removeEventListener("goHome", () => {
        navigate("/");
      });
    };
  }, [navigate]);

  useEffect(() => {
    handleValidateToken();
    if (window.Android) {
      if (isPlayerOpen) {
        document.body.classList.add("playing");
      } else {
        document.body.classList.remove("playing");
        if (window.Android) {
          window.Android.destroyPlayer();
        }
      }
    }
  }, [isPlayerOpen]);

  useEffect(() => {
    getConfigs();
    if (window.Android) {
      os(() => {});
    }
  }, []);

  useEffect(() => {
    const local = localStorage.getItem("language");

    if (local) {
      const parsed = JSON.parse(local);
      if (parsed) {
        setTranslationId(parsed.id);
      }
    }
  }, []);

  return (
    <>
      {localStorage.getItem("is_blocked") ? (
        <Modal
          isOpen={true}
          onClose={() => {}}
          size="full"
          classNames="blocked-modal"
        >
          <div className="blocked-modal-content">
            <img src={sadCloud} alt="blocked" className="sad-cloud-img" />
            <h2 className="blocked-modal-title">You are blocked</h2>
            {lockMessage ? (
              <p className="blocked-modal-description">{lockMessage}</p>
            ) : null}
          </div>
        </Modal>
      ) : null}
      <TranslationProvider langId={translationId}>
        <Modal
          isOpen={!isConnected}
          onClose={() => {}}
          size="full"
          classNames="connection-modal"
        >
          <h2 className="no-interen-title">No internet connection</h2>
          <p>Please check your internet connection and try again</p>
        </Modal>
        <Modal isOpen={isApkModalOpen} onClose={() => {}} size="full">
          <h2 className="no-interen-title">There is a new version available</h2>

          <InoRow isActive={true} classNames="apk-update_row">
            <InoButton
              isActive
              variant="outline"
              size="large"
              classNames="apk-update_btn close"
              onClick={() => {
                setIsApkModalOpen(false);
                dispatch(setIsUpdateModalOpen(false));
              }}
            >
              {t("Close")}
            </InoButton>
            <InoButton
              isActive
              size="large"
              variant="outline"
              classNames="apk-update_btn update"
              onClick={() => {
                updateApkHandler();
                setIsApkModalOpen(false);
                dispatch(setIsUpdateModalOpen(false));
              }}
            >
              {t("Update")}
            </InoButton>
          </InoRow>
        </Modal>
        <InoToastProvider>
          <ToastProvider>
            <Routes>
              <Route
                path={PATHS.SPLASH_SCREEN}
                index
                element={<SplashScreen />}
              />
              <Route path={PATHS.MENU} element={<Menu />} />
              <Route
                path={PATHS.ACTIVATION_PAGE}
                element={<ActivationPage />}
              />
              <Route path={PATHS.LIVE} element={<LivePage />} />
              <Route path={PATHS.SETTINGS} element={<Settings />} />

              <Route
                path={PATHS.MOVIES}
                element={
                  <MoviesProvider>
                    <MoviesPage />
                  </MoviesProvider>
                }
              />
              <Route path={PATHS.MOVIE_INFO} element={<MovieInfo />} />

              {/* Only show Apps route if launcher functionality is enabled */}
              {(() => {
                try {
                  const appSettings = localStorage.getItem("app_settings");
                  if (appSettings) {
                    const settings = JSON.parse(appSettings);
                    if (settings.launcher === false) {
                      return null; // Don't render apps route when launcher is disabled
                    }
                  }
                  return <Route path={PATHS.APPS} element={<AppsPage />} />;
                } catch (err) {
                  // Default to showing apps route if there's an error parsing settings
                  return <Route path={PATHS.APPS} element={<AppsPage />} />;
                }
              })()}
            </Routes>
          </ToastProvider>
        </InoToastProvider>
      </TranslationProvider>
    </>
  );
}

export default memo(App);
